export default {
    apps: {
        googleTagManager: {
            id: "google-tag-manager",
            callback: null,
        },

        googleNoScript: {
            id: "google-tag-manager-noscript",
            callback: null,
        },

        googleMap: {
            id: "googlemap-js",
            callback: null,
        },

        barestho: {
            id: "barestho-widget",
            callback: iframe => {
                iframe.removeAttribute('srcdoc');
            },
        },
    },

    categories: {
        required: {
            default: true,
            apps: null,
        },

        analytics: {
            default: false,
            apps: [
                "googleTagManager", "googleNoScript"
            ],
        },

        thirdParty: {
            default: false,
            apps: [
                "googleMap", "barestho"
            ],
        }
    },
};